import { render } from "./PlansSection.vue?vue&type=template&id=6dbe2830&scoped=true"
import script from "./PlansSection.vue?vue&type=script&lang=js"
export * from "./PlansSection.vue?vue&type=script&lang=js"

import "./PlansSection.vue?vue&type=style&index=0&id=6dbe2830&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guifernandespro\\development\\projects\\vue_icon-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbe2830"]])

export default __exports__